{
  "filter": "Filtro",
  "filters": "Filtri",
  "ok": "OK",
  "cancel": "Annulla",
  "close": "Arresta",
  "delete": "Eliminare",
  "update": "Modificare",
  "remove": {
    "user": "Eliminare un utente"
  },
  "search": "Cercare",
  "back": "Indietro",
  "validate": "Conferma",
  "save": "Salvare",
  "archive": "Archivio",
  "send": "Inviare",
  "disable": "Inattivo",
  "enable": "Attivo",
  "create": {
    "_": "Nuovo",
    "rootCa": "Caricare la root CA"
  },
  "next": "Avanti",
  "previous": "Indietro",
  "test": {
    "pki": "Test della connessione"
  },
  "slider": {
    "enable": "Attivare la selezione",
    "disable": "Disattivare la selezione"
  },
  "download": "Download",
  "add": "Aggiungere",
  "import": "Importazione",
  "retryLogin": "Riprovare a identificarsi",
  "retryLogout": "Riprovare a disconnettersi",
  "confirm": "Conferma",
  "deactivate": "Disattiva",
  "activate": "Attiva",
  "upload": "Carica",
  "copied": "Copiato",
  "copiedTitle": "Copia negli appunti",
  "edit": "Modifica"
}
